import { Box, Flex } from '@podiumhq/design-system';

import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

export const SelectPlanCheckoutContentFlexWrapper = ({
  children,
  ...props
}) => {
  const { isMobile } = useCheckoutContext() || {};

  return (
    <Flex
      align={isMobile ? 'center' : 'flex-start'}
      direction={isMobile ? 'column' : 'row'}
      justify={isMobile ? 'center' : 'flex-start'}
      {...props}
    >
      {children}
    </Flex>
  );
};

export const SelectPlanCheckoutContentBox = ({ children, ...props }) => {
  const { isMobile } = useCheckoutContext() || {};

  return (
    <Box
      mr={isMobile ? 0 : '120px'}
      width={isMobile ? '100%' : '490px'}
      {...props}
    >
      {children}
    </Box>
  );
};
